import Resume from "../assets/Documents/RAJALAKSHMI_SUDHAKAR_Resume.pdf";

import ProfileImg from "../assets/images/Rashmi.jpg";
import classes from "../styles/Home.module.css";

export default function HomePage() {
  const handleDownload = () => {
    // Trigger the file download
    const link = document.createElement("a");
    link.href = Resume;
    link.download = "Rajalakshmi_Sudhakar_Resume.pdf";
    link.click();
  };

  return (
    <div
      className={classes["home-page"]}
      // style={{ backgroundImage: `url(${BGImage})` }}
    >
      <div className={classes["home-page-container"]}>
        <div className={classes["home-page-content"]}>
          <h2>Hello I'm</h2>
          <h1>Rajalakshmi Sudhakar</h1>
          <p>
            {" "}
            Web Developer proficient in React.js, HTML, CSS, JavaScript, and
            modern web technologies, with a strong foundation in C/C++
            programming and over 4 years of experience in the telecom industry.
          </p>
          <h4>Explore my comprehensive experience.</h4>
          <div className={classes["home-btns"]}>
            <button className={classes.btn} onClick={handleDownload}>
              Download Resume
            </button>
          </div>
        </div>
        <div className={classes["home-page-image"]}>
          <img src={ProfileImg} alt="my Profile" />
        </div>
      </div>
    </div>
  );
}
